<template>
  <div v-if="isLoading" class="b-loading__wrap" style="z-index: 1000">
    <div class="b-loading">
      <img
        src="../../../assets/images/Artboard 1_800.jpg"
        alt="loading_image"
      >
    </div>
  </div>
</template>
<script>
  export default {
    computed: {
      isLoading() {
        return this.$store.state.fileLoading.isLoading;
      }
    }
  };
</script>
